<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="addServiceConfig.isOpen"
    id="add-sidebar"
  >
    <div class="flex items-center justify-between px-6 pb-2">
      <h4 class="font-bold text-2xl">Add New Service</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="sidebar-content p-6 overflow-auto add-service-form">
        <!-- <p>Service Name</p> -->
        <div class="add-service-avatar-container">
          <h4 class="text-lg font-bold">Service image</h4>
          <avatar-uploader class="my-avatar-uploader" :isFromService="true" v-if="addServiceConfig.isOpen" :user="avatarServiceData" @uploaded-done="handleUploaded"></avatar-uploader>
        </div>
        <h4 class="font-bold text-lg mb-3">Service name</h4>
        <vs-input placeholder="Service Name" v-validate="'required'" name="name" v-model="name" class="w-full" :danger="errors.has('name')"
              danger-text="The service name field is required" v-on:keypress="formatName" />
        <!-- <p>Service description</p> -->
        <h4 class="font-bold text-lg mb-3 mt-4">Service description</h4>
        <vs-textarea v-model="note" height="70"/>
        <!-- <p>Service duration</p> -->
        <h4 class="font-bold text-lg mb-3 mt-4">Service duration</h4>
        <vs-row>
          <vs-col vs-w="6" class="pr-3">
            <v-select v-model="selectedHour" :options="hours" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" :clearable="false" :searchable="false"/><br>
          </vs-col>
          <vs-col vs-w="6" class="pl-3">
            <v-select v-model="selectedMinute" :options="minutes" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" :clearable="false" :searchable="false"/><br>
          </vs-col>
        </vs-row>
        <!-- <p>Service price</p> -->
        <h4 class="font-bold text-lg mb-3">Service price</h4>
        <vs-input v-model="price" v-on:keypress="isNumber($event)" icon="attach_money" class="w-full mb-5" :clearable="false" :searchable="false" :maxlength="9" :disabled="leave_blank"/>
        <div class="flex align-center"><vs-checkbox class="m-0 mr-2 mb-6" v-model="leave_blank">Leave blank</vs-checkbox></div>
        <!-- <vs-row>
          <vs-col vs-w="6" class="pr-3 service-price">
            <v-select v-model="selectedPrice" :options="prices" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" :clearable="false" :searchable="false"/><br>
          </vs-col>
          <vs-col vs-w="6" class="pl-3">
            <div v-if="selectedPrice.id === 2">
              <vs-input v-model="price" v-on:keypress="isNumber($event)" icon="attach_money" class="w-full" :clearable="false" :searchable="false" :maxlength="9"/>
            </div>
          </vs-col>
        </vs-row> -->
        <h4 class="font-bold text-lg mb-3">Supply share</h4>
        <vs-input v-model="supply_share" v-on:keypress="isNumber($event)" class="w-full" />
        <!-- <p>Category Name</p> -->
        <h4 class="font-bold text-lg mb-4">Category name</h4>
        <v-select @input="selectId($event)" label="name" :options="serviceData" v-model="cateId" class="w-full" disabled :clearable="false" :searchable="false"></v-select>
        <!-- <span class="text-danger text-xs error-text-input span-text-validation hide-error pl-1" :class="{'show-error': has_err}">The category field is required</span> -->
        <!-- <p>Online booking visibility</p> -->
        <h4 class="font-bold text-lg mb-6 mt-4">Visibility</h4>
        <div class="flex align-center"><vs-checkbox class="m-0 mr-2" v-model="status">Service visible to client during online booking.</vs-checkbox></div>
        <p class="text-grey-custom" style="font-size: 12px">When enabled, this service will appear in your Booking Site and Embedded Widgets. This will not affect your ability to choose it when you create an appointment.</p>
        <div v-if="config.service_distinction">
        <!-- <vs-checkbox class="m-0 mr-2 mb-6" v-model="gocheckin_available">Service visible on GoCheckin.</vs-checkbox> -->
        <!-- <vs-checkbox class="m-0 mr-2 mb-6" v-model="gobooking_available">Service available on GoBooking.</vs-checkbox> -->
        <!-- <vs-checkbox class="m-0 mr-2 mb-6" v-model="gopos_available">Service visible on GoPos.</vs-checkbox> -->
        <!-- <vs-checkbox class="m-0 mr-2" v-model="gobooking_available">Service available on GoBooking.</vs-checkbox> -->
          <div class="flex my-3">
            <div class="flex">
              <vs-switch v-model="gocheckin_available" class="mr-3"></vs-switch>Shown on Go Check In
            </div>
            <div class="flex ml-12">
              <vs-switch v-model="gopos_available" class="mr-3"></vs-switch>Shown on POS
            </div>
          </div>
        </div>
        <!-- <v-select label="name" :options="distinctionSelect" v-model="distinctionValue" class="w-full" :clearable="false" :searchable="false" v-if="config.service_distinction"></v-select> -->
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click="submitData" style="min-width: 140px">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: "vs-add-service",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    'v-select': vSelect,
  },
  props: {
    isActive: { type: Boolean },
    addServiceConfig: {
      type: Object,
      required: true
    },
    serviceData: {
      type: Array,
      required: false
    },
    activeServiceData: {
      type: Object,
      required: true
    },
    activeStaffData: {
      type: Object,
      required: true,
    }
  },
  data() {
      return {
          number0: 0,
          status: true,
          name :"",
          cateId: this.activeStaffData.name,
          selectedId: this.activeStaffData.id,
          note:"",
          price: '',
          supply_share: 0,
          hours: [
            {label: '0 hrs' , value: '0'},{label: '1 hrs' , value: '1'},{label: '2 hrs' , value: '2'},{label: '3 hrs' , value: '3'},
            {label: '4 hrs' , value: '4'},{label: '5 hrs' , value: '5'},{label: '6 hrs' , value: '6'},{label: '7 hrs' , value: '7'},
            {label: '8 hrs' , value: '8'},{label: '9 hrs' , value: '9'},{label: '10 hrs' , value: '10'},{label: '11 hrs' , value: '11'},
            {label: '12 hrs' , value: '12'},{label: '13 hrs' , value: '13'},{label: '14 hrs' , value: '14'},
          ],
          selectedHour: {label: '0 hrs' , value: '0'},
          minutes: [
            {label: '0 mins' , value: '0'},{label: '5 mins' , value: '5'},{label: '10 mins' , value: '10'},{label: '15 mins' , value: '15'},
            {label: '20 mins' , value: '20'},{label: '25 mins' , value: '25'},{label: '30 mins' , value: '30'},{label: '35 mins' , value: '35'},
            {label: '40 mins' , value: '40'},{label: '45 mins' , value: '45'},{label: '50 mins' , value: '50'},{label: '55 mins' , value: '55'},
          ],
          selectedMinute: {label: '0 mins' , value: '0'},
          prices: [
            {id:1, label: 'Leave blank'},
            {id:2, label: 'Add price'}
          ],
          selectedPrice:{id:1,label: 'Leave blank'},
          id: null,
          has_err: false,
          distinctionSelect: [
            {name: "Show on GoCheckin & GoBooking", value: 0, },
            {name: "Show only on GoCheckin", value: 1, },
            {name: "Show only on GoBooking", value: 2, },
          ],
          distinctionValue: {name: "Show on GoCheckin & GoBooking", value: 0, },
          gocheckin_available: true,
          gobooking_available: true,
          gopos_available: true,
          leave_blank: true,
          image: {
            image_url: null,
            delete_image_url: null,
            image_path: null,
            image_base_url: null
          },
          avatarServiceData: {
            name: this.name,
            color_code: this.activeStaffData.color_detail ? this.activeStaffData.color_detail.color_code : null,
            image_url: this.image
          },
      }
  },
  watch: {
    addServiceConfig: {
      immediate: true,
      deep: true,
      handler() {
        // this.name = '';
        // this.errors = [];
        this.errors.clear();
        if(this.addServiceConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
          if(this.activeStaffData){
            this.cateId  =  this.activeStaffData.name;
            this.selectedId = this.activeStaffData.id;
          }
        } else {
          document.body.classList.remove('overflow-hidden');
          this.name = '';
          if(this.activeStaffData){
            this.cateId  =  this.activeStaffData.name;
            this.selectedId = this.activeStaffData.id;
          }
          this.has_err = false;
          this.note = "";
          this.status = true;
          this.price = '';
          this.selectedHour = {label: '0 hrs' , value: '0'};
          this.selectedMinute = {label: '0 mins' , value: '0'};
          this.gocheckin_available = true;
          this.gobooking_available = true;
          this.leave_blank = true;
          // if(this.activeServiceData.price == null){
          //   this.selectedPrice = {id:1,label: 'Leave blank'};
          // }else{
          //   this.selectedPrice = {id:2, label: 'Add price'};
          // }
        }
      }
    },
    id: {
      immediate: true,
      handler() {
        if(this.id != null) {
          this.has_err = false;
        }
      }
    }
  },
  computed:{
    service_cateId: {
        get() {
          return this.cateId;
        },
        set(value) {
          this.cateId = value;
        }
    },
    config(){
      return this.$store.getters['auth/config'];
    }
    //  id:{
    //     get() {console.log(this.serviceData);return this.serviceData.id;},
    //     set(value) {
    //       console.log(value)
    //     }
    //   }
  },
  methods: {
    handleUploaded(data) {
      this.image = data;
    },
    removeAccents(str) {
      return str.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/đ/g, 'd').replace(/Đ/g, 'D');
    },
    formatName() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.name = this.removeAccents(this.name);
      }, 500);
    },
    isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.price.indexOf(".") != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    selectId(e) {
      this.selectedId = e.id
    },
    closeSidebar() {
      this.$emit("CloseSidebar");
    },
    submitData(){
      if(this.selectedId == null){
        this.selectedId = '';
      }
      let group_id = "both";
      if (this.gocheckin_available == true && this.gobooking_available == false){
        group_id = 1;
      } else if (this.gocheckin_available == false && this.gobooking_available == true){
        group_id = 2;
      }
      if(this.name != ''){
        const obj = {
        name: this.removeAccents(this.name),
        category_id: (this.selectedId != 999999) ? this.selectedId : 999999,
        cate_name: this.cateId,
        // image_url: this.image.image_url,
        image_path: this.image.image_path,
        image_base_url: this.image.image_base_url,
        // id: (this.selectedId != 999999) ? this.selectedId : '',
        web_booking_visible: this.status ? 1 : 0,
        // price: this.price == '' ? '' : parseFloat(this.price),
        price: this.leave_blank || this.price == '' ? '' : parseFloat(this.price),
        note: this.note,
        duration: parseInt(this.selectedHour.value*60) + parseInt(this.selectedMinute.value),
        group_id,
        supply_share: this.supply_share,
        status: 1,
        show_on_checkin: (this.gocheckin_available) ? 1 : 0,
        show_on_booking: (this.gobooking_available) ? 1 : 0,
        show_on_pos: (this.gopos_available) ? 1 : 0,
      }
        this.$emit("AddService" , obj);
        this.closeSidebar();
      }
      if(this.id == null) {
        this.has_err = true;
      }
      this.$validator.validateAll();
    },
  }
};
</script>
